import React, { useEffect, useState } from "react";
import ProductCatalogueView from "./ProductCatalogueView";
import StoreList from "./StoreList";
import { useOutletContext } from "react-router-dom";
import OrderSummaryView from "./OrderSummaryView";
import { getCustomerProfileDetails } from "../../services/authServices";
import { decryptData } from "../../utils/crypto";
import Utils from "../../utils";
import SetPinPage from "./SetPinPage";
import { notify } from "../../components/Common/Alerts";

const StorePOSView = () => {
  const {
    selectedProductStore,
    setSelectedSProductStore,
    showSummary,
    setShowSummary,
    setShowCatalogue,
    showCatalogue,
    pinModelOpen,
    setPinModelOpen,
    setPinData,
    pinData,
    setUpdateModel,
    updateModel,
    isModalDeleteOpen,
    setIsModalDeleteOpen,
    setCartData,
    cartData,
    setIsModalCurrentPinDeleteOpen,
    isModalCurrentPinOpen,
  } = useOutletContext();
  const [customerDetailsData, setCustomerDetailsData] = useState("");
const isWalletStoreDetails =
  location.pathname.startsWith("/wallet-store-details");

  const handleSelectStore = (store) => {
    if (selectedProductStore?.id !== store.id) {
      setCartData([]);
    }
    setSelectedSProductStore(store);
    setShowCatalogue(true);
  };

  useEffect(() => {
    getCustomerProfileDetails()
      .then((response) => {
        const decrypted = decryptData(response.data.data);
        const dataList = decrypted.data;

        setCustomerDetailsData(dataList);
      })
      .catch((err) => {
        notify.error(Utils.getErrorMessage(err));
      });
  }, []);

  return (
    // <>
    //   {!selectedProductStore || !showCatalogue ? (
    //     <StoreList
    //       onSelectStore={handleSelectStore}
    //       selectedProductStore={selectedProductStore}
    //       setPinModelOpen={setPinModelOpen}
    //       pinModelOpen={pinModelOpen}
    //     />
    //   ) : showSummary ? (
    //     <OrderSummaryView
    //       store={selectedProductStore}
    //       cartData={cartData}
    //       onBack={() => setShowSummary(false)}
    //       customerDetailsData={customerDetailsData}
    //       setCartData={setCartData}
    //       setSelectedSProductStore={setSelectedSProductStore}
    //     />
    //   ) : (
    //     <ProductCatalogueView
    //       store={selectedProductStore}
    //       onBack={() => setShowCatalogue(false)} // go back to store list
    //       cartData={cartData}
    //       setCartData={setCartData}
    //       setShowSummary={setShowSummary}
    //     />
    //   )}
    // </>

    <>
      {pinModelOpen ? (
        <SetPinPage
          store={selectedProductStore}
          onClose={() => setPinModelOpen(false)}
          pinData={pinData}
          selectedProductStore={selectedProductStore}
          setShowCatalogue={setShowCatalogue}
          setCartData={setCartData}
          setSelectedSProductStore={setSelectedSProductStore}
          setPinModelOpen={setPinModelOpen}
          setUpdateModel={setUpdateModel}
          updateModel={updateModel}
          isModalDeleteOpen={isModalDeleteOpen}
          setIsModalDeleteOpen={setIsModalDeleteOpen}
        />
      ) : !selectedProductStore || (!showCatalogue && !isWalletStoreDetails) ? (
        <StoreList
          onSelectStore={handleSelectStore}
          selectedProductStore={selectedProductStore}
          setPinModelOpen={setPinModelOpen}
          pinModelOpen={pinModelOpen}
          setPinData={setPinData}
          pinData={pinData}
          setUpdateModel={setUpdateModel}
          updateModel={updateModel}
          setShowCatalogue={setShowCatalogue}
          isModalDeleteOpen={isModalDeleteOpen}
          setIsModalDeleteOpen={setIsModalDeleteOpen}
          setIsModalCurrentPinDeleteOpen={setIsModalCurrentPinDeleteOpen}
          isModalCurrentPinOpen={isModalCurrentPinOpen}
        />
      ) : showSummary ? (
        <OrderSummaryView
          store={selectedProductStore}
          cartData={cartData}
          onBack={() => setShowSummary(false)}
          customerDetailsData={customerDetailsData}
          setCartData={setCartData}
          setSelectedSProductStore={setSelectedSProductStore}
          setShowCatalogue={setShowCatalogue}
          setShowSummary={setShowSummary}
          setUpdateModel={setUpdateModel}
          setPinModelOpen={setPinModelOpen}
          setPinData={setPinData}
          isModalDeleteOpen={isModalDeleteOpen}
          setIsModalDeleteOpen={setIsModalDeleteOpen}
        />
      ) : (
        <ProductCatalogueView
          store={selectedProductStore}
          onBack={() => setShowCatalogue(false)}
          cartData={cartData}
          setCartData={setCartData}
          setShowSummary={setShowSummary}
          setShowCatalogue={setShowCatalogue}
          isModalDeleteOpen={isModalDeleteOpen}
          setIsModalDeleteOpen={setIsModalDeleteOpen}
        />
      )}
    </>
  );
};

export default StorePOSView;
